/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import uuid from 'uuid/v4';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Anchor from './ItemsComponents/Anchor';
import ArtistsList from './ItemsComponents/ArtistsList';
import Carousel from './ItemsComponents/Carousel';
import CollapsibleFAQs from './ItemsComponents/CollapsibleFAQsComponents/CollapsibleFAQs';
import CollapsibleListComponent from './ItemsComponents/CollapsibleListComponent';
import ContactForm from './ItemsComponents/ContactFormReusable';
import FilterContainer from './ItemsComponents/FilterContainer';
import FullLink from './ItemsComponents/FullLink';
import GalleryModule from './ItemsComponents/GalleryModule';
import IframeComponent from './ItemsComponents/IframeComponent';
import ImageModule from './ItemsComponents/ImageModule';
import PdfModule from './ItemsComponents/PdfModule';
import InstructionsModule from './ItemsComponents/InstructionsModule';
import Launcher from './ItemsComponents/Launcher';
import Launcher2 from './ItemsComponents/Launcher2';
import LogosRowModule from './ItemsComponents/LogosRowModule';
import MapModule from './ItemsComponents/MapModule';
import MediaTitle from './ItemsComponents/MediaTitle';
import MediaRowDraggable from './ItemsComponents/MediaRowDraggable';
import MultioptionsButtons from './ItemsComponents/MultioptionsButtons';
import LineupIsOnNow from './ItemsComponents/LineupIsOnNow';
import ParagraphModule from './ItemsComponents/ParagraphModule';
import PostDescriptionRow from './ItemsComponents/PostDescriptionRow';
import PostInformationBox from './PostInformationBox';
import ReusableComponent from './ItemsComponents/ReusableComponent';
import Separator from './ItemsComponents/Separator';
import SpotifyPlayer from './ItemsComponents/SpotifyPlayer';
import StructureLanguageTabs from './StructureLanguageTabs';
import TitleLineH1 from './ItemsComponents/TitleLineH1';
import TitleLineH2 from './ItemsComponents/TitleLineH2';
import TitleLineH3 from './ItemsComponents/TitleLineH3';
import NumberedList from './ItemsComponents/NumberedList';
import FilterBlock from './ItemsComponents/FilterBlock';
import SearchBasicLayout from './ItemsComponents/SearchBasicLayout';
import Tickets from './ItemsComponents/Tickets';
import TicketsPageTemplate from './ItemsComponents/TicketsPageTemplate';
import VideoPlayerModule from './ItemsComponents/VideoPlayerModule';
import NativeVideoPlayerModule from './ItemsComponents/NativeVideoPlayerModule';
import TagsRow from './ItemsComponents/TagsRow';
import LineupContainer from './ItemsComponents/LineupContainer';
import ArtistsCloud from './ItemsComponents/ArtistsCloud';
import TestAB from './ItemsComponents/TestAB';
import PureReusableComponent from './ItemsComponents/PureReusableComponent';
import RadioList from './ItemsComponents/RadioList';
import LoadIcon from '../../LoadIcon';
import NewsLetterPreferencesModule from './ItemsComponents/NewsLetterPreferencesModule';
import NewsletterSubscribeWidgetReusable from './ItemsComponents/NewsletterSubscribeWidgetReusable';
import StreamModule from './ItemsComponents/PrimaveraWorld/StreamModule';
import ZoneSectionModule from './ItemsComponents/PrimaveraWorld/ZoneSectionModule';
import BannerModule from './ItemsComponents/PrimaveraWorld/BannerModule';
import OnDemandAccessButtonSimple from './ItemsComponents/PrimaveraWorld/OnDemandAccessButtonSimple';
import SimpleOnDemandBanner from './ItemsComponents/PrimaveraWorld/SimpleOnDemandBanner';
import ProOnDemandAccessButton from './ItemsComponents/ProOnDemandAccessButton';
import RedtktAccessButton from './ItemsComponents/RedtktAccessButton';
import GroupedItems from './ItemsComponents/GroupedItems';
import Newsletter from './ItemsComponents/Newsletter';
import TaggedItem from './ItemsComponents/TaggedItem';
import TagsBlock from './ItemsComponents/TagsBlock';
import SharingBlock from './ItemsComponents/SharingBlock';
import ExplodedModule from './ItemsComponents/ExplodedModule';
import BackCatalogue from './ItemsComponents/BackCatalogue';
import BannersRow from './ItemsComponents/BannersRow';
import AudioPlayer from './ItemsComponents/AudioPlayer';
import SocialLogosContainer from './ItemsComponents/SocialLogosContainer';
import TableList from './ItemsComponents/TableList';
import PdfMagazineGallery from './ItemsComponents/PdfMagazineGallery';
import Postal from './ItemsComponents/Postal';
import BrazeTrigger from './ItemsComponents/BrazeTrigger';
import RadioChannel from './ItemsComponents/RadioChannel';
import MapBox from './ItemsComponents/MapBox';
import MainNavMenu from './ItemsComponents/MainNavMenu';
import RegistrationConfig from './ItemsComponents/RegistrationConfig';
import TicketsTabs from './ItemsComponents/TicketsTabs';
import Embed from './ItemsComponents/Embed';
import CustomHtml from './ItemsComponents/CustomHtml';
import WideBanner from './ItemsComponents/WideBanner';
import MapData from './ItemsComponents/MapData';
import LoginPaywall from './ItemsComponents/LoginPaywall';
import FanSaleSignup from './ItemsComponents/FanSaleSignup';
import Wishlist from './ItemsComponents/Wishlist';
import Calendar from './ItemsComponents/Calendar';

import itemsModules, {
  anchorItems, textItems, mediaItems, extraItems, reusableItems, mediaItemsStreaming, allItems,
} from './ItemsModules/items';
import { copy, reorder } from '../../../utils/dragAndDrop';
// import checkTemplateType from '../../../utils/checkTemplateType';
import getPostsByType from '../../../api/graphql/queries/getPostsByType';
import Countdown from "./ItemsComponents/Countdown";
import ImageWrapper from "./ItemsComponents/ImageWrapper";
import SimpleScheduleTable from "./ItemsComponents/SimpleScheduleTable";

// styles
const grid = 8;

const getItemStyleContent = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  color: 'white',
  padding: grid * 1.5,
  paddingLeft: '40px',
  margin: `0 0 ${grid * 1.5}px 0`,
  borderRadius: '4px',
  fontFamily: 'GT-America-Mono-Regular',
  textTransform: 'uppercase',
  cursor: 'grab',
  zIndex: 9999,
  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '#292929',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getItemStyleType = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 4,
  border: '1px solid #dae1e7',
  borderRadius: '10px',
  // margin: '2rem 1.25rem 1.250rem',
  // change background colour if dragging
  background: 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyleContent = isDraggingOver => ({
  background: 'black',
  padding: '0px 22px 6px 22px',
  width: '100%',
});

const getListStyleType = isDraggingOver => ({
  background: isDraggingOver ? 'rgba(0,0,0,.5)' : 'white',

  // padding: grid,
  overflowY: 'auto',
  height: '78vh',
  // width: '98%',
  borderRadius: '0 0 5px 5px',
  // position: 'absolute',
  // left: '20px',
  // top: '50px',
});

const DragAndDropContainer = ({
  selectedOnDragAndDrop,
  handlerSetSelectedOnDragAndDrop,
  post,
  toggleEdit,
  toggleRefetch,
  sendPost,
  isCollapsible,
  addStatusMessage,
  templateType,
  updatePost,
}) => {
  const [textIsOpen, setTextIsOpen] = useState(false);
  const [allIsOpen, setAllIsOpen] = useState(false);
  const [anchorIsOpen, setAnchorIsOpen] = useState(false);
  const [mediaIsOpen, setMediaIsOpen] = useState(false);
  const [extraIsOpen, setExtraIsOpen] = useState(false);
  const [reusableIsOpen, setReusableIsOpen] = useState(false);

  const [showAllItems, setShowAllItems] = useState(false);

  const [selected, setSelected] = useState([]);
  const [isLoading, setLoadingStatus] = useState(true);

  const [itemsAll, setItemsAll] = useState([]);
  const [itemsForAnchor, setItemsForAnchor] = useState(anchorItems);
  const [itemsForText, setItemsForText] = useState(textItems);
  const [itemsForMedia, setItemsForMedia] = useState(mediaItems);
  const [itemsForExtra, setItemsForExtra] = useState(extraItems);
  const [itemsForReusable, setItemsForReusable] = useState(reusableItems);
  const [reusableComponents, setReusableComponents] = useState([]);

  const [sidebarVisible, setSidebarVisible] = useState(true);


  const [showItem, setShowItem] = useState([]);

  // Intented for reusable components???
  // TO-DO: Needed to refactor this >>
  useEffect(() => {
    const fetchData = async () => {
      const result = await getPostsByType('component');
      setReusableComponents(result.posts);
    };
    fetchData();
  }, []);

  const handlerSetComponents = (comp, index) => {
    const { component } = comp;

    const newSelected = selected;
    newSelected[index].component = { ...component };
    setSelected(newSelected);
    handlerSetSelectedOnDragAndDrop(newSelected);
  };

  const handlerSetCarouselComponents = (comp, index) => {
    const newSelected = selected;
    const modifiedCompsWithId = comp.map((c) => {
      const mc = { ...c };
      if (c.component && !c.component.compId) {
        mc.component.compId = `${c.component.type}_${uuid()}`;
      }
      if (mc?.component?.components?.length) {
        const modifiedCompsInComps = mc.component.components.map((cc) => {
          const mcc = { ...cc };
          if (cc.component && !cc.component.compId) {
            mcc.component.compId = `${cc.component.type}_${uuid()}`;
          }
          return mcc;
        });
        mc.component.components = modifiedCompsInComps;
      }
      return mc;
    });
    newSelected[index].component.components = modifiedCompsWithId;
    setSelected(newSelected);
    setLoadingStatus(false);
    handlerSetSelectedOnDragAndDrop(newSelected);
  };

  // "Requires user login": common per-component flag, kept on the wrapper item
  // (NOT item.component — the per-type forms rebuild that object from their own
  // state and would drop it). Serialized next to compId in PostContainer's
  // getComponentsArray via applyRequiresLogin. PS-only for now: the checkbox is
  // hidden on the RDL admin (an existing flag would still round-trip untouched
  // through hydration + serialization, it just can't be set or cleared there).
  const handlerToggleRequiresLogin = (id) => {
    const index = selected.map(i => i.id).indexOf(id.toString());
    if (index < 0) return;
    const arr = [...selected];
    arr[index] = { ...arr[index], requiresLogin: arr[index].requiresLogin !== true };
    setSelected(arr);
    handlerSetSelectedOnDragAndDrop(arr);
  };

  const handleBlockClose = (id) => {
    const itemToBeRemovedIndex = selected.map(i => i.id).indexOf(id.toString());
    const arr = [...selected];
    arr.splice(itemToBeRemovedIndex, 1);
    setSelected(arr);
    handlerSetSelectedOnDragAndDrop(arr);
  };

  // logic to update reusable component name, currently commented out as it is causing a loop.
  const handleReadableNameReusable = (slug, moduleName) => {
    // const newSelectedIncludingObjWithReadableName = [...selected].map((i) => {
    //   if (i.content === slug) {
    //     i.readableName = moduleName;
    //     return i;
    //   }
    //   return i;
    // });
    // setSelected(newSelectedIncludingObjWithReadableName);
  };

  useEffect(() => {
    // handle items that come from the post itself

    setSelected(selectedOnDragAndDrop);
    setLoadingStatus(false);
  }, [selectedOnDragAndDrop]);

  // TO-DO : Refactor this >>>
  // I understand that this try to check for a kind of layout and
  // sets type of modules suitables for this kind of type of page
  useEffect(() => {
    if (templateType) {
      const mediaItemsToBeUsed = templateType === 'SingleStreamPage' ? mediaItemsStreaming : mediaItems;

      setItemsAll([]);
      setItemsForAnchor(anchorItems);
      setItemsForText(textItems);
      setItemsForMedia(mediaItemsToBeUsed);
      setItemsForExtra(extraItems);
      setItemsForReusable(reusableItems);
    }
  }, [itemsModules, templateType]);

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        const newOrder = reorder(selected, source.index, destination.index);
        handlerSetSelectedOnDragAndDrop(newOrder); // push changes to parent container

        setSelected(newOrder);
        break;
      }
      // moving items from left to right columns (adding components to selected list)

      case 'all': {
        const makeCopy = copy(itemsAll, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      case 'anchors': {
        const makeCopy = copy(itemsForAnchor, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      case 'text': {
        const makeCopy = copy(itemsForText, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      case 'media': {
        const makeCopy = copy(itemsForMedia, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      case 'extra': {
        const makeCopy = copy(itemsForExtra, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      case 'reusable': {
        const makeCopy = copy(itemsForReusable, selected, source, destination);
        handlerSetSelectedOnDragAndDrop(makeCopy);
        setSelected(makeCopy);
        break;
      }

      default: {
        break;
      }
    }
  };

  const handleModulesSearch = (e) => {
    e.preventDefault();
    const searchParam = e.target.value.toLowerCase();
    const searchParamLowerCased = searchParam ? searchParam.toLowerCase() : '';

    if (searchParamLowerCased && searchParamLowerCased.length > 2) {
      const filteredItems = allItems.filter(item => item.content.toLowerCase().includes(searchParamLowerCased) || item.readableName.toLowerCase().includes(searchParamLowerCased)) || [];
      setItemsAll(filteredItems);
    } else {
      setItemsAll([]);
    }
  };

  const setVisibleItemFromDragBox = (id) => {
    showItem[id] = !showItem[id];
    setShowItem({ ...showItem });
  };

  return (
    <div>
      <div
        className="absolute bg-black font-bold p-2 rounded-r-full text-white top-0 cursor-pointer"
        onClick={() => setSidebarVisible(!sidebarVisible)}
      >
        {sidebarVisible ? '>' : 'X'}
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="flex w-full">
          <div
            style={{ minWidth: 300 }}
            className={`w-1/4 ${sidebarVisible ? 'hidden' : 'block'} plg:block pin overflow-y-visible overflow-x-hidden scrollbar__black pr-4 pb-2`}
          >
            {post && (
              <PostInformationBox
                addStatusMessage={addStatusMessage}
                selectedOnDragAndDrop={selectedOnDragAndDrop}
                toggleRefetch={toggleRefetch}
                toggleEdit={toggleEdit}
                post={post}
                sendPost={sendPost}
                templateType={templateType}
                updatePost={updatePost}
              />
            )}
            <h3 className="bg-black border-dashed border-greyWithinForm text-greyText pb-4 font-americaMonoRegular uppercase text-sm pt-1 flex flex-row justify-between pt-6 pl-6 rounded-t">Content Type</h3>
            <Droppable droppableId="all" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className="">
                  <div
                    className="border-b border-t border-dashed border-greyWithinForm font-americaMonoRegular uppercase text-white text-sm py-1 flex items-center pl-1 flex flex-row justify-between"
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer">
                      <span className="font-icon icon-search text-white text-lg pr-4" />
                      <input className="p-2 bg-black text-white outline-none uppercase" type="text" onChange={handleModulesSearch} placeholder="TYPE TO SEARCH MODULES" />
                    </div>
                    <span className=" cursor-pointer font-icon text-white text-xxs" />
                  </div>
                  <div className="">
                    {itemsAll && itemsAll.length
                      ? itemsAll.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      )) : null}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable droppableId="anchors" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className={`${anchorIsOpen && 'border-b border-greyWithinForm pr-2'}`}>
                  <div
                    onClick={() => {
                      setAnchorIsOpen(!anchorIsOpen);
                    }}
                    className={`${!anchorIsOpen && 'border-b'} border-greyWithinForm font-americaMonoRegular uppercase text-white text-sm pb-4 pt-3 flex items-center pl-1 flex flex-row justify-between`}
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer mt-2">
                      <span className="font-icon icon-flag text-white text-lg pr-4" />
                      Anchors
                    </div>
                    <span className={`${anchorIsOpen ? 'icon-arrow-up text-white' : 'icon-arrow-down text-greyWithinForm font-black'} cursor-pointer font-icon text-white text-xxs`} />
                  </div>
                  <div className="">
                    {anchorIsOpen
                      && itemsForAnchor.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                    {' '}

                  </div>
                </div>
              )}
            </Droppable>
            <Droppable droppableId="text" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className={`${textIsOpen && 'border-b border-greyWithinForm pr-2'}`}>
                  <div
                    onClick={() => {
                      setTextIsOpen(!textIsOpen);
                    }}
                    className={`${!textIsOpen && 'border-b border-greyWithinForm'} bg-black font-americaMonoRegular uppercase text-white text-sm pb-4 pt-3 flex items-center pl-1 flex flex-row justify-between`}
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer">
                      <span className="font-icon icon-text text-white text-lg pr-4" />
                      Text
                    </div>
                    <span className={`${textIsOpen ? 'icon-arrow-up text-white' : 'icon-arrow-down text-greyWithinForm font-black'} cursor-pointer font-icon text-white text-xxs`} />
                  </div>
                  <div className="">
                    {textIsOpen
                      && itemsForText.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable droppableId="media" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className={`${mediaIsOpen && 'border-b border-greyWithinForm pr-2'}`}>
                  <div
                    onClick={() => {
                      setMediaIsOpen(!mediaIsOpen);
                    }}
                    className={`${!mediaIsOpen && 'border-b border-greyWithinForm'} font-americaMonoRegular uppercase text-white text-sm pb-4 pt-3 flex items-center pl-1 flex flex-row justify-between`}
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer">
                      <span className="font-icon icon-picture-1 text-white text-lg pr-4 font-thin" />
                      Media
                    </div>
                    <span className={`${mediaIsOpen ? 'icon-arrow-up text-white' : 'icon-arrow-down text-greyWithinForm font-black'} cursor-pointer font-icon text-white text-xxs`} />
                  </div>
                  <div className="">
                    {mediaIsOpen
                      && itemsForMedia.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable droppableId="extra" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className={`${extraIsOpen && 'border-b border-greyWithinForm pr-2'}`}>
                  <div
                    onClick={() => {
                      setExtraIsOpen(!extraIsOpen);
                    }}
                    className={`${!extraIsOpen && 'border-b border-greyWithinForm'} bg-black font-americaMonoRegular uppercase text-white text-sm pb-4 pt-3 flex items-center pl-1 flex flex-row justify-between`}
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer">
                      <span className="font-icon icon-add-button2 text-white text-lg pr-4 font-thin" />
                      Extra
                    </div>
                    <span className={`${extraIsOpen ? 'icon-arrow-up text-white' : 'icon-arrow-down text-greyWithinForm font-black'} cursor-pointer font-icon text-white text-xxs`} />
                  </div>
                  <div className="">
                    {extraIsOpen
                      && itemsForExtra.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable droppableId="reusable" isDropDisabled>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)} className={`rounded-b ${reusableIsOpen && 'border-b border-greyWithinForm pr-2'}`}>
                  <div
                    onClick={() => {
                      setReusableIsOpen(!reusableIsOpen);
                    }}
                    className="bg-black font-americaMonoRegular uppercase text-white text-sm pb-4 pt-3 flex items-center pl-1 flex flex-row justify-between"
                  >
                    <div className="flex flex-row items-center font-semibold cursor-pointer">
                      <span className="font-icon icon-sync text-white text-lg pr-4 font-thin" />
                      Reusable
                    </div>
                    <span className={`${reusableIsOpen ? 'icon-arrow-up text-white text-greyWithinForm font-black' : 'icon-arrow-down text-white font-black'} cursor-pointer font-icon text-white text-xxs`} />
                  </div>
                  <div className="">
                    {reusableIsOpen
                      && itemsForReusable.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                              {item.readableName}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
          </div>
          <div className="w-full h-full">
            {post.slugName ? (
              <Droppable droppableId="selected">

                {(provided, snapshot) => (

                  <StructureLanguageTabs style>
                    {(activeLanguage, languages) => (
                      <div className="h-73vh xxxl:h-83vh relative w-full" ref={provided.innerRef} style={getListStyleType(snapshot.isDraggingOver)}>
                        <div className="pb-2 pt-8 px-5 sticky top-0 w-full z-top bg-white rounded">
                          <div className="bg-blue w-full flex p-4 items-center justify-between rounded ">

                            <div className="font-americaMonoRegular text-10 uppercase">
                              {`Template: ${templateType}`}
                            </div>

                            <div className="flex flex-wrap items-center">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">OPEN ALL</label>
                              <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                                <input
                                  type="checkbox"
                                  value={showAllItems}
                                  onChange={() => setShowAllItems(!showAllItems)}
                                  checked={showAllItems}
                                  className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4
                                  appearance-none cursor-pointer"
                                />
                                <label className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
                              </div>
                            </div>

                          </div>
                        </div>
                        {selected.length > 0
                          && selected.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index} activeLanguage={activeLanguage}>
                              {(provided, snapshot, component) => (

                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyleType(snapshot.isDragging, provided.draggableProps.style)}
                                  className="relative mx-5 my-2"
                                >

                                  {/* <button className="absolute pin-l pin-t" style={{ marginTop: '-19px', marginLeft: '2px' }} type="button">
                                  <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded">{item.readableName}</span>
                                </button>
                                <button
                                  className="absolute pin-r flex items-center justify-center z-20"
                                  style={{ marginTop: '-19px', marginRight: '2px' }}
                                  type="button"
                                  onClick={() => {
                                    handleBlockClose(item.id);
                                  }}
                                >
                                  <span className="font-icon icon-close-solid text-16 text-black" />
                                </button> */}
                                  <div className="flex">
                                    <div className="w-10">
                                      <div
                                        className={
                                          `
                                    h-full w-full
                                    bg-greyFilterItems text-greyFilter text-30
                                    flex items-center justify-center
                                    rounded-tl-lg roundend-bl-lg
                                    `
                                        }
                                        {...provided.dragHandleProps}
                                      >
                                        =
                                      </div>
                                    </div>
                                    <div className="w-full">
                                      <div className="w-full p-4">
                                        <div className="flex justify-between" {...provided.dragHandleProps}>
                                          {item.placeholder ? (
                                            <div className="bg-blue-darker block leading-normal
                                          font-bold opacity-25 p-2 pt-3 rounded text-white text-xs
                                          tracking-wide uppercase"
                                            >
                                              {item.readableName}
                                            </div>
                                          ) : (
                                            <button
                                              className="bg-blue-darker block
                                  font-bold p-2 rounded text-white text-xs
                                  tracking-wide uppercase
                                  relative pr-8"
                                              type="button"
                                              onClick={() => setVisibleItemFromDragBox(item.id)}
                                            >
                                              {item.readableName}

                                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-10 top-0">
                                                <svg
                                                  className={`fill-current h-4 w-4 ${showItem[item.id] ? 'rotate-180' : ''}`}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 20 20"
                                                >
                                                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                </svg>
                                              </div>
                                            </button>
                                          )}
                                          <div className="flex items-center">
                                            {!item.placeholder && process.env.APP_NAME !== 'rdl' && (
                                              <label
                                                className="bg-grey-lighter flex items-center mr-4 p-2 rounded text-black text-xs font-bold uppercase tracking-wide cursor-pointer select-none"
                                                title="Logged-out visitors will see a login button instead of this component. On already-published pages the change applies after the site cache is purged or expires."
                                              >
                                                <input
                                                  type="checkbox"
                                                  className="mr-2"
                                                  checked={item.requiresLogin === true}
                                                  onChange={() => handlerToggleRequiresLogin(item.id)}
                                                />
                                                <span className="text-black">Requires user login</span>
                                              </label>
                                            )}
                                            <button
                                              className="bg-blue-darker font-bold p-2 rounded tracking-wide"
                                              type="button"
                                              onClick={() => {
                                                handleBlockClose(item.id);
                                              }}
                                            >
                                              <span className="font-icon icon-close-btn1 text-base text-white" />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      {((showItem[item.id] || showAllItems) && !item.placeholder) && (
                                        <div className="pb-4 px-4 w-full">
                                          {item.content === 'TitleLineH1' && <TitleLineH1 languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'ArtistsCloud' && <ArtistsCloud languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'TestAB' && <TestAB languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'ReusableComponent' && <PureReusableComponent languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'TagsRow' && <TagsRow languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'LineupContainer' && <LineupContainer languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'TitleLineH2' && <TitleLineH2 languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'TitleLineH3' && <TitleLineH3 languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'SpotifyPlayer' && <SpotifyPlayer handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {(item.content === 'MediaTitle' || item.content === 'DoubleTitle') && <MediaTitle languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'NormalBodyText' && <ParagraphModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Carousel' && <Carousel selectedOnDragAndDrop={selectedOnDragAndDrop} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} handlerSetCarouselComponents={handlerSetCarouselComponents} id={item.id} components={selected} />}
                                          {item.content === 'FilterContainer' && <FilterContainer toggleRefetch={toggleRefetch} handleReadableNameReusable={handleReadableNameReusable} reusableComponents={reusableComponents} selectedOnDragAndDrop={selectedOnDragAndDrop} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} handlerSetCarouselComponents={handlerSetCarouselComponents} id={item.id} components={selected} />}
                                          {/* {item.content === 'PostDescriptionRow' && <PostDescriptionRow languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />} */}
                                          {item.content === 'PostDescriptionRow' && <MediaRowDraggable componentType="PostDescriptionRow" selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'LogosRowModule' && <LogosRowModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'MediaDescription' && <ImageModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Pdf' && <PdfModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Gallery' && <GalleryModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} reusableComponentSlugname={item.reusableCompSlugName} toggleRefetch={toggleRefetch} />}
                                          {item.content === 'CarouselWithDescription' && <GalleryModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} reusableComponentSlugname={item.reusableCompSlugName} toggleRefetch={toggleRefetch} isCarousel />}
                                          {item.content === 'Separator' && !isCollapsible && <Separator languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Separator' && isCollapsible && <Anchor languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'FullLink' && <FullLink languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'VideoPlayer' && <VideoPlayerModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'NativeVideoPlayer' && <NativeVideoPlayerModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'StreamModule' && <StreamModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'ZoneSection' && <ZoneSectionModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'BannerModule' && <BannerModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'OnDemandAccessButtonSimple' && <OnDemandAccessButtonSimple languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'SimpleOnDemandBanner' && <SimpleOnDemandBanner languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'ProOnDemandAccessButton' && <ProOnDemandAccessButton languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'RedtktAccessButton' && <RedtktAccessButton languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'LineupContainerSimple' && <CollapsibleFAQs languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'CardsTickets' && <Tickets languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} type="CardsTickets" />}
                                          {item.content === 'CarouselTickets' && <Tickets languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} type="CarouselTickets" />}
                                          {(item.content === 'InstructionsSimpleUploadLogo' || item.content === 'InstructionsSimple') && <InstructionsModule languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Map' && <MapModule handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.type === 'reusableItem' && <ReusableComponent id={item.id} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} content={item.content} components={selected} handleReadableNameReusable={handleReadableNameReusable} toggleRefetch={toggleRefetch} />}
                                          {item.content === 'Tickets' && <Tickets languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Launcher' && <Launcher handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'Launcher2' && <Launcher2 handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'RadioEpisodesList' && <RadioList handlerSetComponents={handlerSetComponents} id={item.id} components={selected} type="RadioEpisodesList" />}
                                          {item.content === 'RadioShows' && <RadioList handlerSetComponents={handlerSetComponents} id={item.id} components={selected} type="RadioShows" />}
                                          {item.content === 'LineupList' && <ArtistsList languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'CollapsibleList' && <CollapsibleListComponent post={post} reusableComponents={reusableComponents} selectedOnDragAndDrop={selectedOnDragAndDrop} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} handlerSetCarouselComponents={handlerSetCarouselComponents} id={item.id} components={selected} />}
                                          {item.content === 'ContactFormReusable' && <ContactForm selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'IframeComponent' && <IframeComponent selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'NewsLetterSettingsModule' && <NewsLetterPreferencesModule selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'NewsletterSubscribeWidgetReusable' && <NewsletterSubscribeWidgetReusable selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'PosterRow' && <MediaRowDraggable componentType="PosterRow" selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'MultioptionsButtons' && <MultioptionsButtons selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'LineupIsOnNow' && <LineupIsOnNow selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'GroupedItems' && <GroupedItems selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'FilterBlock' && <FilterBlock selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'SearchBasicLayout' && <SearchBasicLayout selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'Newsletter' && <Newsletter selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'TaggedItem' && <TaggedItem selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'TagsBlock' && <TagsBlock selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'Calendar' && <Calendar selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} activeLanguage={activeLanguage} />}
                                          {item.content === 'SharingBlock' && <SharingBlock selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'SocialLogosContainer' && <SocialLogosContainer selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'NumberedList' && <NumberedList selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'ExplodedModule' && <ExplodedModule selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'BackCatalogue' && <BackCatalogue selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'BannersRow' && <BannersRow selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'AudioPlayer' && <AudioPlayer selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'TableList' && <TableList selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {/* {item.content === 'CollapsibleList' && post.slugName === 'tickets' && <TicketsPageTemplate selectedOnDragAndDrop={selectedOnDragAndDrop} languages={languages} activeLanguage={activeLanguage} handlerSetComponents={handlerSetComponents} handlerSetCarouselComponents={handlerSetCarouselComponents} id={item.id} components={selected} />} */}
                                          {/* {item.content === 'paragraph2' && <ParagraphModule storeText={storeText} lang={lang} state={state || ''} name={item.content} />} */}
                                          {item.content === 'PdfMagazineGallery' && <PdfMagazineGallery selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'Postal' && <Postal selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'MapBox' && <MapBox selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'BrazeTrigger' && <BrazeTrigger selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'RadioChannel' && <RadioChannel selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'MainNavMenu' && <MainNavMenu selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'RegistrationConfig' && <RegistrationConfig handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'TicketsTabs' && <TicketsTabs selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'Embed' && <Embed selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'CustomHtml' && <CustomHtml handlerSetComponents={handlerSetComponents} id={item.id} components={selected} />}
                                          {item.content === 'WideBanner' && <WideBanner handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'MapData' && <MapData selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'Countdown' && <Countdown selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'ImageWrapper' && <ImageWrapper selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'SimpleScheduleTable' && <SimpleScheduleTable selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'LoginPaywall' && <LoginPaywall selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                          {item.content === 'FanSaleSignup' && <FanSaleSignup handlerSetComponents={handlerSetComponents} id={item.id} components={selected} activeLanguage={activeLanguage} />}
                                          {item.content === 'Wishlist' && <Wishlist selectedOnDragAndDrop={selectedOnDragAndDrop} handlerSetComponents={handlerSetComponents} id={item.id} components={selected} languages={languages} activeLanguage={activeLanguage} />}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </StructureLanguageTabs>
                )}
              </Droppable>
            ) : <LoadIcon />}
          </div>
        </div>
      </DragDropContext>
    </div>
  );
};

export default DragAndDropContainer;
